import { DeclinedVideoCamera, MissedVideoCamera } from '@bizzabo/design-system';
import { MissedCallTypes, AttendeeType } from './types';

export const getMissedCallObj = (name: string) => {
    return {
        [MissedCallTypes.CALL_TIMEOUT]: {
            [AttendeeType.HOST]: {
                title: `${name} can’t meet right now`,
                text: `Try again later or send a message.`,
                icon: <DeclinedVideoCamera title="declined call img" titleId="declined call img" />,
            },
            [AttendeeType.GUEST]: {
                title: `${name} tried to meet with you`,
                text: 'Meet now by clicking the "Meet" button or follow up with a message.',
                icon: <MissedVideoCamera title="missed call img" titleId="missed call img" />,
            },
        },
        [MissedCallTypes.CALL_DECLINED]: {
            [AttendeeType.HOST]: {
                title: `${name} can’t meet right now`,
                text: `Try again later or send a message.`,
                icon: <DeclinedVideoCamera title="declined call img" titleId="declined call img" />,
            },
            [AttendeeType.GUEST]: {
                title: `Can't meet now?`,
                text: 'You can start a meeting later with the "Meet" button above.',
                icon: <DeclinedVideoCamera title="declined call img" titleId="declined call img" />,
            },
        },
        [MissedCallTypes.CALL_CANCELED]: {
            [AttendeeType.HOST]: {
                title: null,
                text: null,
                icon: null,
            },
            [AttendeeType.GUEST]: {
                title: `${name} tried to meet with you`,
                text: 'Meet now by clicking the "Meet" button or follow up with a message.',
                icon: <MissedVideoCamera title="missed call img" titleId="missed call img" />,
            },
        },
        [MissedCallTypes.GUEST_BUSY]: {
            [AttendeeType.HOST]: {
                title: `${name} can’t meet right now`,
                text: `Try again later or send a message.`,
                icon: <DeclinedVideoCamera title="declined call img" titleId="declined call img" />,
            },
            [AttendeeType.GUEST]: {
                title: `${name} tried to meet with you`,
                text: `Meet now by clicking the "Meet" button or follow up with a message`,
                icon: <MissedVideoCamera title="missed call img" titleId="missed call img" />,
            },
        },
    };
};

export const isHideMessage = (messageType: MissedCallTypes, attendeeType: AttendeeType) => {
    return messageType === MissedCallTypes.CALL_CANCELED && attendeeType === AttendeeType.HOST;
};
